import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import {
  Mapping,
  MappingField,
  MappingIdentifier,
} from 'src/containers/ProjectDiagram/types/data';
import { CreateMappingOverrideOptions } from 'src/containers/ProjectDiagram/types/mapping';
import { getMappingLabelKey } from 'src/containers/ProjectDiagram/utils/mapping/createMappingLabel';
import { getResourceKey } from 'src/containers/ProjectDiagram/utils/resource/createResource';

export type CreateMappingOptions = {
  points?: number[];
  value: string;
  text: string;
  label?: string | null;
  primaryIdentifier?: MappingIdentifier;
  fields?: Record<string, MappingField>;
  uniqueKeySets?: string[];
} & CreateMappingOverrideOptions;

export const getMappingKey = ({
  fromId,
  value,
  toKey,
}: {
  fromId?: string;
  value: string;
  toKey?: string;
}) => `${LinkCategory.MAPPING}-${fromId}-${value}-${toKey}`;

export const getMappingKeyFromLabelKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkLabelCategory.MAPPING_LABEL}`),
    LinkCategory.MAPPING
  );

export const createMapping = ({
  fromId,
  value,
  toKey,
  text,
  points,
  label = null,
  primaryIdentifier = { baseIri: null, parts: [] },
  fields = {},
  keyOverride,
  labelKeyOverride,
  uniqueKeySets = [],
}: CreateMappingOptions): Mapping => ({
  key: keyOverride || getMappingKey({ fromId, value, toKey }),
  from: getResourceKey(fromId),
  value,
  to: toKey,
  text,
  labelKeys: [labelKeyOverride || getMappingLabelKey({ fromId, value, toKey })],
  category: LinkCategory.MAPPING,
  points,
  label,
  primaryIdentifier,
  fields,
  setClassType: true,
  uniqueKeySets,
});
